var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_1059)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.4551,
    cy: 32,
    r: 27,
    fill: "url(#paint0_linear_102_1059)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.4551,
    cy: 32,
    r: 26.25,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4542 21.3635C43.5735 21.3635 44.7215 21.3923 45.8343 21.4395L47.1486 21.5023L48.4066 21.5769L49.5848 21.6568L50.6609 21.7405C51.8288 21.8294 52.928 22.3276 53.7647 23.1473C54.6014 23.967 55.122 25.0557 55.2348 26.2216L55.2872 26.7779L55.3854 27.9692C55.477 29.2037 55.5451 30.5494 55.5451 31.8363C55.5451 33.1231 55.477 34.4688 55.3854 35.7033L55.2872 36.8946L55.2348 37.4509C55.122 38.617 54.6012 39.7059 53.7642 40.5256C52.9272 41.3453 51.8278 41.8434 50.6596 41.932L49.5861 42.0144L48.4079 42.0956L47.1486 42.1702L45.8343 42.233C44.7082 42.2818 43.5813 42.3071 42.4542 42.309C41.3271 42.3071 40.2002 42.2818 39.0741 42.233L37.7598 42.1702L36.5018 42.0956L35.3236 42.0144L34.2475 41.932C33.0795 41.8431 31.9804 41.3449 31.1437 40.5252C30.307 39.7055 29.7864 38.6168 29.6735 37.4509L29.6212 36.8946L29.523 35.7033C29.4233 34.4166 29.37 33.1268 29.3633 31.8363C29.3633 30.5494 29.4314 29.2037 29.523 27.9692L29.6212 26.7779L29.6735 26.2216C29.7863 25.0559 30.3068 23.9674 31.1432 23.1477C31.9796 22.328 33.0785 21.8297 34.2462 21.7405L35.321 21.6568L36.4991 21.5769L37.7585 21.5023L39.0728 21.4395C40.1993 21.3907 41.3267 21.3653 42.4542 21.3635ZM39.836 28.6617V35.0108C39.836 35.6156 40.4906 35.9926 41.0142 35.6915L46.5124 32.517C46.632 32.4481 46.7314 32.3489 46.8005 32.2294C46.8696 32.1099 46.906 31.9743 46.906 31.8363C46.906 31.6982 46.8696 31.5626 46.8005 31.4431C46.7314 31.3236 46.632 31.2244 46.5124 31.1555L41.0142 27.9823C40.8947 27.9133 40.7593 27.877 40.6213 27.8771C40.4834 27.8771 40.3479 27.9134 40.2285 27.9824C40.1091 28.0514 40.01 28.1506 39.941 28.2701C39.8721 28.3896 39.8359 28.5251 39.836 28.663V28.6617Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_1059",
    x: 0.455078,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_1059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_1059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_1059",
    x1: 15.4551,
    y1: 5,
    x2: 69.4551,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E5E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube1);
export default __webpack_public_path__ + "static/media/youtube (1).e4638d9cdd55b49e3a6397da407855d8.svg";
export { ForwardRef as ReactComponent };